import { action, observable } from 'mobx';
import { RemoteResourceV3, updateRemoteResourceV3 } from '../../../../../commonv3/api/RemoteResourceV3';
import { PlanIndexView } from '../../../../types/plans';
import { SubscriptionsApis } from '../../../../apis/subscriptions';

export class UpdateSubscriptionNotificationState {
    @observable subscriptions: RemoteResourceV3<PlanIndexView[]> = RemoteResourceV3.loading();

    @action.bound
    async init() {
        await this.loadSubscriptions();
    }

    @action.bound
    async loadSubscriptions() {
        await updateRemoteResourceV3(
            this.subscriptions,
            (v) => (this.subscriptions = v),
            () => SubscriptionsApis.findAll()
        );
    }
}
